const TREE_COUNT_API =
    'https://storage.googleapis.com/setmorewebsite_language_bucket/admin/standard/assets/v2/common/tree-counter.json';

export const FALLBACK_TREE_COUNT = '2,151,014';

const isValidTreeCountResponse = (response) => (
    response
    && typeof response === 'object'
    && typeof response.count === 'string'
    && response.count.length > 0
);

export const getTreesCount = () => fetch(TREE_COUNT_API)
    .then((response) => {
        if (!response.ok) {
            throw new Error('Trees Counter: Network response error');
        }

        return response.json();
    })
    .then((parsedResponse) => {
        if (!isValidTreeCountResponse(parsedResponse)) {
            return FALLBACK_TREE_COUNT;
        }

        return parsedResponse.count;
    })
    .catch((error) => {
        console.log('Error fetching tree count:', error);
        return FALLBACK_TREE_COUNT;
    });



// WEBPACK FOOTER //
// ./src/js/utils/get-trees-count.js